import { Donut } from '../../../Common/Charts/Donut';
import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const TotalOcurrencesMedicalRegulation = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <Donut
            title={'Ocorrência de chamados com regulação médica pelo total de ocorrências'}
            subtitles={chartData?.medicalRegIndex?.map((item) => item.description)}
            chartData={chartData?.medicalRegIndex || []}
            colors={defaultColors.slice(0, chartData?.medicalRegIndex?.length) || []}
            height={400}
            percentage={true}
        />
    );
};
